import services from '@/config/services'

export default class FornitoriService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async getAllItemsForMindTable(opts = {}){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/fornitori/search`

    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems
      }
    }

  }

  getAllColumnsForMindTable(){
    return [
      {
        property: 'code',
        label: 'Codice',
        // type: {
        //   isBoolean:true
        //   isCurrency:true
        //   isDate: true
        // },
        default: true,
      },
      {
        property: 'ragsoc',
        label: 'Denominazione',
        sortable: true,
        default: true,
      },
      {
        property: 'codfis',
        label: 'Codice Fiscale',
      },
      {
        property: 'piva',
        label: 'Partita IVA',
        default: true,
      },
      {
        property: 'email',
        label: 'Email',
      },
      {
        property: 'Telefono',
        label: 'telefono',
      },
    ]
  }

  async getDettaglioFornitore(id){
    let item = {}

    const url = `${this.baseUrl}/fornitori/${id}`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async updateInfo(id, info){
    let item = {}
    let success = false

    const url = `${this.baseUrl}/fornitori/${id}/info`
    try {
      let res = await this.http.put(url, {data: info})
      res = res.data

      item = res.data
      success = res.meta.success
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success
      }
    }
  }

}
